/**
 * The delay in milliseconds to wait before invalidating the cache.
 * Ensures the dropdown animation finishes and that the backend catches up.
 */
export const INVALIDATE_DELAY = 400;
